module.exports = __webpack_public_path__ + "static/motion-3-7bb913b03c3be18f96bbc46933a0769d.mp4";